import $ from 'jquery';

function loadFavoriteCount(){
  return new Promise((resolve, reject) => {
    $.ajax({
        type: 'GET',
        url: '/content/favorites/count',
        success: function(data){
          resolve(data);
        },
        failure: function(){},
        error: function(error) {
          reject(error);
        }
    });
  });
}

export default loadFavoriteCount();


// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/header/load-favorite-count.js